import ImportedComponent0 from "../../../../src/docs/sdk/event-payloads/properties/type.mdx";
import ImportedComponent1 from "../../../../src/docs/sdk/event-payloads/properties/span_start_timestamp.mdx";
import ImportedComponent2 from "../../../../src/docs/sdk/event-payloads/properties/span_timestamp.mdx";
import ImportedComponent3 from "../../../../src/docs/sdk/event-payloads/properties/span_id.mdx";
import ImportedComponent4 from "../../../../src/docs/sdk/event-payloads/properties/parent_span_id.mdx";
import ImportedComponent5 from "../../../../src/docs/sdk/event-payloads/properties/trace_id.mdx";
import ImportedComponent6 from "../../../../src/docs/sdk/event-payloads/properties/op.mdx";
import ImportedComponent7 from "../../../../src/docs/sdk/event-payloads/properties/description.mdx";
import ImportedComponent8 from "../../../../src/docs/sdk/event-payloads/properties/status.mdx";
import ImportedComponent9 from "../../../../src/docs/sdk/event-payloads/properties/spans.mdx";
import ImportedComponent10 from "../../../../src/docs/sdk/event-payloads/properties/measurements.mdx";
import ImportedComponent11 from "../../../../src/docs/sdk/event-payloads/properties/transaction_info.mdx";
import * as React from 'react';
export default {
  ImportedComponent0,
  ImportedComponent1,
  ImportedComponent2,
  ImportedComponent3,
  ImportedComponent4,
  ImportedComponent5,
  ImportedComponent6,
  ImportedComponent7,
  ImportedComponent8,
  ImportedComponent9,
  ImportedComponent10,
  ImportedComponent11,
  React
};